import { useState } from 'react';
import { useListLogs } from '@/api/logs/logs';
import { useGetDailySummary } from '@/api/summary/summary';
import { Card, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/field';
import { kcal, toDateParam } from '@/lib/utils';

/** Browse any past day (spec §13 "Log detail"). */
export function History() {
  const [date, setDate] = useState(() => toDateParam(new Date()));

  const summary = useGetDailySummary({ date });
  const logs = useListLogs({ date });

  return (
    <>
      <Card className="space-y-3">
        <CardTitle>เลือกวัน</CardTitle>
        <Input
          type="date"
          value={date}
          max={toDateParam(new Date())}
          onChange={(event) => setDate(event.target.value)}
          aria-label="วันที่"
        />
      </Card>

      <Card className="grid grid-cols-2 gap-3 text-center">
        <div>
          <p className="text-xs text-ink-muted">กินไป</p>
          <p className="text-2xl font-semibold tabular-nums">{kcal(summary.data?.consumed)}</p>
        </div>
        <div>
          <p className="text-xs text-ink-muted">
            {(summary.data?.remaining ?? 0) < 0 ? 'เกินงบ' : 'เหลือ'}
          </p>
          <p className="text-2xl font-semibold tabular-nums">
            {kcal(summary.data?.remaining == null ? null : Math.abs(summary.data.remaining))}
          </p>
        </div>
      </Card>

      <Card className="space-y-3">
        <CardTitle>รายการ</CardTitle>

        {logs.isPending && <p className="text-sm text-ink-muted">กำลังโหลด…</p>}
        {logs.data?.length === 0 && <p className="text-sm text-ink-muted">ไม่มีรายการวันนี้</p>}

        <ul className="divide-y divide-border-subtle">
          {logs.data?.map((log) => (
            <li key={log.id} className="flex items-center gap-3 py-2.5">
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium">{log.name}</p>
                <p className="text-xs text-ink-muted">
                  {new Date(log.loggedAt).toLocaleTimeString('th-TH', {
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'Asia/Bangkok',
                  })}
                  {' · '}
                  {Math.round(log.grams)} g
                </p>
              </div>
              <p className="shrink-0 text-sm tabular-nums">{kcal(log.kcal)} kcal</p>
            </li>
          ))}
        </ul>
      </Card>
    </>
  );
}
